import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Observable } from "rxjs";
import { HttpclientService } from "../../../../shared";
import { NotificationReportRequest } from "./notification-report-request";

@Injectable()
export class DataService_PortalAppNotificationLog {
	constructor(private httpclientService: HttpclientService) {}

	GradeLevelSelectList(SchoolID: number) {
		var postResult$ = new Subject();
		var url = "Report/GradeLevelRPTGetList?ApplicationItemID=&SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AcademySelectList(SchoolID: number) {
		var postResult$ = new Subject();
		var url = "Report/AcademyGetList?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	HomeroomSelectList(SchoolID: number) {
		var postResult$ = new Subject();
		var url = "Report/HomeroomGetList?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GroupSelectList(SchoolID: number) {
		var postResult$ = new Subject();
		var url = "Report/GroupGetList?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	NotificationLogSelectList(parms: NotificationReportRequest) {
		var postResult$ = new Subject();
		var url = "PortalApps/NotificationLogSelectList";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	RegAppTypeSelectList() {
		var postResult$ = new Subject();
		var url = "PortalApps/RegAppTypeSelectList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
